"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
/** Time in ms to throttle the resize events by default. */
var core_1 = require("@angular/core");
var platform_1 = require("@angular/cdk/platform");
var common_1 = require("@angular/common");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
exports.DEFAULT_RESIZE_TIME = 20;
var ViewportRuler = /** @class */ (function () {
    function ViewportRuler(_platform, ngZone, document) {
        var _this = this;
        this._platform = _platform;
        /** Stream of viewport change events. */
        this._change = new Subject_1.Subject();
        /** Event listener that will be used to handle the viewport change events. */
        this._changeListener = function (event) {
            _this._change.next(event);
        };
        this._document = document;
        ngZone.runOutsideAngular(function () {
            if (_platform.isBrowser) {
                var window_1 = _this._getWindow();
                // Note that bind the events ourselves, rather than going through something like RxJS's
                // `fromEvent` so that we can ensure that they're bound outside of the NgZone.
                window_1.addEventListener('resize', _this._changeListener);
                window_1.addEventListener('orientationchange', _this._changeListener);
            }
            // We don't need to keep track of the subscription,
            // because we complete the `change` stream on destroy.
            _this.change().subscribe(function () { return _this._updateViewportSize(); });
        });
    }
    ViewportRuler.prototype.ngOnDestroy = function () {
        if (this._platform.isBrowser) {
            var window_2 = this._getWindow();
            window_2.removeEventListener('resize', this._changeListener);
            window_2.removeEventListener('orientationchange', this._changeListener);
        }
        this._change.complete();
    };
    /** Returns the viewport's width and height. */
    ViewportRuler.prototype.getViewportSize = function () {
        if (!this._viewportSize) {
            this._updateViewportSize();
        }
        var output = { width: this._viewportSize.width, height: this._viewportSize.height };
        // If we're not on a browser, don't cache the size since it'll be mocked out anyway.
        if (!this._platform.isBrowser) {
            this._viewportSize = null;
        }
        return output;
    };
    /** Gets a ClientRect for the viewport's bounds. */
    ViewportRuler.prototype.getViewportRect = function () {
        var scrollPosition = this.getViewportScrollPosition();
        var _a = this.getViewportSize(), width = _a.width, height = _a.height;
        return {
            top: scrollPosition.top,
            left: scrollPosition.left,
            bottom: scrollPosition.top + height,
            right: scrollPosition.left + width,
            height: height,
            width: width,
        };
    };
    /** Gets the (top, left) scroll position of the viewport. */
    ViewportRuler.prototype.getViewportScrollPosition = function () {
        if (!this._platform.isBrowser) {
            return { top: 0, left: 0 };
        }
        var document = this._document;
        var window = this._getWindow();
        var documentElement = document.documentElement;
        var documentRect = documentElement.getBoundingClientRect();
        var top = -documentRect.top || document.body.scrollTop || window.scrollY ||
            documentElement.scrollTop || 0;
        var left = -documentRect.left || document.body.scrollLeft || window.scrollX ||
            documentElement.scrollLeft || 0;
        return { top: top, left: left };
    };
    /**
     * Returns a stream that emits whenever the size of the viewport changes.
     * @param throttleTime Time in milliseconds to throttle the stream.
     */
    ViewportRuler.prototype.change = function (throttleTime) {
        if (throttleTime === void 0) { throttleTime = exports.DEFAULT_RESIZE_TIME; }
        return throttleTime > 0 ? this._change.pipe(operators_1.auditTime(throttleTime)) : this._change;
    };
    /** Use defaultView of injected document if available or fallback to global window reference */
    ViewportRuler.prototype._getWindow = function () {
        return this._document.defaultView || window;
    };
    /** Updates the cached viewport size. */
    ViewportRuler.prototype._updateViewportSize = function () {
        var window = this._getWindow();
        this._viewportSize = this._platform.isBrowser ?
            { width: window.innerWidth, height: window.innerHeight } :
            { width: 0, height: 0 };
    };
    ViewportRuler = __decorate([
        core_1.Injectable(),
        __param(2, core_1.Optional()), __param(2, core_1.Inject(common_1.DOCUMENT)),
        __metadata("design:paramtypes", [platform_1.Platform,
            core_1.NgZone, Object])
    ], ViewportRuler);
    return ViewportRuler;
}());
exports.ViewportRuler = ViewportRuler;
//# sourceMappingURL=viewport-ruler.js.map